import { getState } from 'pluginServices/store';
import { selectCurrentMe } from 'data/CurrentUser/selectors';

class UserServices {
  constructor({ context, id }) {
    this.context = context;
    this.id = id;
  }

  getUser(accountId) {
    if (accountId) { throw new Error('get user by id not implemented'); }
    const account = selectCurrentMe(getState());
    if (account) {
      const { email, primaryEmail, ...otherDetails } = account;
      return otherDetails;
    }
    return null;
  }

  static build(args) {
    return new UserServices(args);
  }
}

export default UserServices;
